<!-- <div class="background">
  <div class="grid login-box">
    <div class="col-lg-4 container">
      <div class="text-center border-round-sm font-bold">
        <div class="panel center white-background">

          <div class="panel-body">
            <img class="logo" src="./../../assets/images/logo.png" />
            <h2 class="login-text">Enterprise Project Cost Control</h2>
            <span class="login-text font-normal">Sign In with your Chevron Account</span>
            <p class="login-button">
              <p-button (click)="azureLogin()" class="azure-button m-3 white-font" label="Chevron Users" size="large" />
            </p>
            <span class="login-text font-normal">Sign in with your external account</span>
            <p class="login-button">
              <p-button class="m-3 white-font" (click)="oktaLogin()" label="External Users" size="large" /><br />
            </p>
          </div>

        </div>
      </div>
    </div>
  </div>
</div> -->


<div class="background d-flex justify-content-center align-items-center vh-100">
  <div class="login-box col-lg-4 col-md-6 col-sm-8 p-4 shadow rounded bg-white text-center">
    <!-- <img class="logo mb-3" src="./../../assets/images/hallmark.png" alt="Logo" />
    <h3 class="login-text font-weight-bold">TA Pro <br>Scheduler's Portal</h3> -->
    <p class="login-text font-normal">Sign in with your Chevron Account</p>
    <p class="login-button">
      <p-button (click)="azureLogin()" class="azure-button m-3 white-font" label="Chevron Users" size="large" />
    </p>
    <span class="login-text font-normal">Sign in with your external account</span>
    <p class="login-button">
      <p-button class="m-3 white-font" (click)="oktaLogin()" label="External Users" size="large" /><br />
    </p>
  </div>
</div>


    <p-dialog
        header="Access Required from Primavera"
        [modal]="true"
        [(visible)]="visible"
        [style]="{ width: '30rem' }">
            <p>
              please reach out to the Primavera system administrator to obtain access.
            </p>
    </p-dialog>